import {
  FormattedUpdatingOptionsSummaryData,
  UpdatingOptionsSummaryData
} from '../types';

export function formatUpdatingOptionsSummaryData({
  data,
  paymentManager
}: UpdatingOptionsSummaryData): FormattedUpdatingOptionsSummaryData {
  const minorProducts: { id: string; title: string }[] = [];

  data.productsFirstAmount.forEach(product => {
    if (product.type.minor && product.detained === false) {
      minorProducts.push({
        id: product.id,
        title: product.label
      });
    }
  });
  return {
    allowModart: data.allowModart,
    minorProducts,
    currency: paymentManager.currencyCode,
    amount: paymentManager.amount,
    tax: {
      amount: paymentManager.convertedTaxAmount,
      label: paymentManager.taxLabel
    }
  };
}
